import React from "react";
import PropTypes from "prop-types";

import Size from "components/Size";
import { objectValueNotZero } from "utils";

import styles from "./SpaceSize.css";

const Area = ({ area, isUnitBlack, isValueBold }) => (
  <div className={styles.root}>
    {objectValueNotZero(area) && (
      <Size
        isUnitBlack={isUnitBlack}
        isValueBold={isValueBold}
        unit={area.unit}
        value={area.value}
      />
    )}
  </div>
);

Area.propTypes = {
  area: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  isUnitBlack: PropTypes.bool,
  isValueBold: PropTypes.bool,
};

export default Area;
